import script from "./SomethingWentWrongErrorWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./SomethingWentWrongErrorWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./SomethingWentWrongErrorWrapper.vue?vue&type=style&index=0&id=dcada0ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcada0ae"]])

export default __exports__